// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2d-1";
export var rateTableServiceLevelDropdown = "_2d-3";
export var rateTableTypeDropdown = "_2d-0";
export var rateTableValueModeDropdown = "_2d-2";